import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  CareProgramTemplatemobjbqq2s74k as CareProgramTemplate,
  CareProgramTemplateDated1lvcdu3xhc5up as CareProgramTemplateDated,
  ID3j2ictjlq95nd as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_careTime1h5171nvh773w as get_careTime,
  get_name2lx8u3d4hog3p as get_name,
  get_templateerawh75uwil7 as get_template,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { CareTime_FullTime_getInstance2puuq5c8w5gwp as CareTime_FullTime_getInstance } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/attendance.mjs';
import {
  eq353yrgcpovoi1 as eq,
  inside26mvda7ucvpq5 as inside,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceIn10f36k81le1mm as coerceIn,
  until1jbpn0z3f8lbg as until,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Cents1lsbs5l1tlgw as Cents,
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
  Companion_instance1c40ds0jrup2e as Companion_instance,
  Cents__toString$default_impl_dffhixgwhghxlriorf as Cents__toString$default_impl_dffhix,
  Cents__compareTo_impl_jg87bs1a0ekdl2mvgbq as Cents__compareTo_impl_jg87bs,
  Cents__plus_impl_qsv4s83hvgnvnlu2892 as Cents__plus_impl_qsv4s8,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimeUnit.mjs';
import {
  minusrtzvftl23j9y as minus,
  plus31cnlckpy77fa as plus,
  YearMonth22nahmknr467s as YearMonth,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { renderToString1pjqj7ffu15sz as renderToString } from '../../utils/daterender.mjs';
import {
  getOrNull1go7ef9ldk0df as getOrNull,
  drop3na99dw9feawf as drop,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  plus2lr02ok6jhhxu as plus_0,
  minus1f3bieyodk5vw as minus_0,
  emptyMapr06gerzljqtm as emptyMap,
  toMap1vec9topfei08 as toMap,
  getValue48kllevslyh6 as getValue,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  None_instance1vdtnxdfytk8h as None_instance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  DangerTextSemantic_getInstancetznd91yayzn7 as DangerTextSemantic_getInstance,
  TableSemantic_getInstance3cbunlgg7bvuu as TableSemantic_getInstance,
  TableHeaderSemantic_getInstanceqomb25yoya3n as TableHeaderSemantic_getInstance,
  TableCellSemantic_getInstancej0y7idum3jgg as TableCellSemantic_getInstance,
} from '../../theme/semantics.mjs';
import {
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  get_bold3d63kt1t4c9r5 as get_bold,
  themed2vu67ornd4jps as themed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { estimateEmployerCost22w3x9tgojuhb as estimateEmployerCost } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/employerCostEstimate.mjs';
import {
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  h12aidul0n4qlwh as h1,
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import {
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_1,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
  Companion_getInstance1toimxkidoujm as Companion_getInstance_2,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  iconButton2nzpucy7a6ixd as iconButton,
  keyValue1ck7xpd7fxylw as keyValue,
} from '../components/view-utilities.mjs';
import { rangeTo5xinnemk0fd3 as rangeTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function EmployerCostCalculatorPage$rates$lambda($this$remember) {
  var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
  var tmp = session.get_careProgramTemplates_ojj53j_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp_1 = eq(get_careTime(it), CareTime_FullTime_getInstance());
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(CareProgramTemplate()), arrayOf([]), false));
  var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$9);
  this_0.ascending_ijynum_k$(get_name(it_0));
  var tmp$ret$5 = this_0.build_1k0s4u_k$();
  var templates = $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$5, VOID, 1000)));
  var tmp_3 = session.get_careProgramTemplateDateds_knbayp_k$();
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_4 = serializerOrContextual(createKType(getKClass(CareProgramTemplateDated()), arrayOf([]), false));
  var tmp$ret$13 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it_1 = new (DataClassPathSelf())(tmp$ret$13);
  var tmp_5 = get_template(it_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(templates, 10));
  var _iterator__ex2g4s = templates.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$18 = new (ID())(item._id_1);
    destination.add_utx5q5_k$(tmp$ret$18);
  }
  var tmp$ret$11 = inside(tmp_5, destination);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$remember.invoke_r7m7el_k$(tmp_3.query_so6xq1_k$(new (Query())(tmp$ret$11, VOID, VOID, 10000)));
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s_0.next_20eer_k$();
    if (element.activeRange_1.contains_pio7lx_k$(today())) {
      destination_0.add_utx5q5_k$(element);
    }
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
  var _iterator__ex2g4s_1 = destination_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
    var tmp$ret$24 = new (ID())(element_0.template_1);
    destination_1.put_4fpzoq_k$(tmp$ret$24, element_0);
  }
  var current = destination_1;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = templates.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
    var element_1 = _iterator__ex2g4s_2.next_20eer_k$();
    var tmp0_safe_receiver = current.get_wei43m_k$(new (ID())(element_1._id_1));
    var tmp_6;
    if (tmp0_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_6 = to(element_1, new (Cents())(tmp0_safe_receiver.price_1));
    }
    var tmp0_safe_receiver_0 = tmp_6;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_2.add_utx5q5_k$(tmp0_safe_receiver_0);
    }
  }
  return destination_2;
}
function EmployerCostCalculatorPage$render$lambda(it) {
  return Cents__toDouble_impl_mg3etm(it.inCents_1);
}
function EmployerCostCalculatorPage$render$lambda_0(it) {
  var tmp1_elvis_lhs = it == null ? null : Companion_instance.get_dollars_vjjqkb_k$(it);
  var tmp;
  var tmp_0 = tmp1_elvis_lhs;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = Companion_instance.get_cents_3bbzqx_k$(0);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return new (Cents())(tmp);
}
function EmployerCostCalculatorPage$render$lambda_1($this$iconButton) {
  return 'Previous month';
}
function EmployerCostCalculatorPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.start_1.set_value_v1vabv_k$(minus(this$0.start_1.get_value_j01efc_k$(), 1, Companion_getInstance().MONTH_1));
    return Unit_instance;
  }), 0);
}
function EmployerCostCalculatorPage$render$lambda_2($this$iconButton) {
  return 'Next month';
}
function EmployerCostCalculatorPage$render$lambda$slambda_0(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.start_1.set_value_v1vabv_k$(plus(this$0.start_1.get_value_j01efc_k$(), 1, Companion_getInstance().MONTH_1));
    return Unit_instance;
  }), 0);
}
function EmployerCostCalculatorPage$render$lambda_3(it) {
  return it;
}
function EmployerCostCalculatorPage$render$lambda_4(it) {
  var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
  return coerceIn(tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs, 1, 19);
}
function EmployerCostCalculatorPage$render$lambda_5(it) {
  return it;
}
function EmployerCostCalculatorPage$render$lambda_6(it) {
  return it == null ? 0.0 : it;
}
function EmployerCostCalculatorPage$render$lambda_7($this$keyValue) {
  return 'Total cost';
}
function EmployerCostCalculatorPage$render$lambda_8($this$keyValue) {
  return 'Left at the end';
}
function EmployerCostCalculatorPage$render$lambda$lambda($month, this$0) {
  return ($this$shownWhen) => $month < $this$shownWhen.invoke_r7m7el_k$(this$0.monthCount_1);
}
function EmployerCostCalculatorPage$render$lambda$lambda_0(this$0, $month) {
  return ($this$invoke) => renderToString(plus($this$invoke.invoke_r7m7el_k$(this$0.start_1), $month, Companion_getInstance().MONTH_1));
}
function EmployerCostCalculatorPage$render$lambda$lambda_1(this$0, $month) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = getOrNull($this$invoke.invoke_r7m7el_k$(this$0.estimate_1), $month);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.weekdays_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  };
}
function NumberInput$_get_hint_$ref_e9o7na(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.native_1.attributes_1.native_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 202, VOID, [p0]);
}
function NumberInput$_set_hint_$ref_r2kj42(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.native_1.attributes_1.native_1.placeholder = p0_0;
    return Unit_instance;
  }, 1, 0, 203, VOID, [p0]);
}
function EmployerCostCalculatorPage$render$lambda$lambda_2(this$0, $month, $group) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = getOrNull($this$invoke.invoke_r7m7el_k$(this$0.children_1), $month);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_wei43m_k$(new (ID())($group._id_1));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  };
}
function EmployerCostCalculatorPage$render$lambda$lambda_3($key) {
  return (it) => {
    var tmp0_safe_receiver = it.get_wei43m_k$($key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
  };
}
function EmployerCostCalculatorPage$render$lambda$lambda_4($key) {
  return (old, new_0) => new_0 == null ? minus_0(old, $key) : plus_0(old, to($key, numberToInt(new_0)));
}
function EmployerCostCalculatorPage$render$lambda_9($this$table, it) {
  return $this$table;
}
function EmployerCostCalculatorPage$render$lambda_10($this$text) {
  return 'Month';
}
function EmployerCostCalculatorPage$render$lambda_11($this$text, it) {
  return renderToString(it.month_1);
}
function EmployerCostCalculatorPage$render$lambda_12($this$text) {
  return 'Care (employer share)';
}
function EmployerCostCalculatorPage$render$lambda_13($this$text, it) {
  return Cents__toString$default_impl_dffhix(it.care_1, VOID, true);
}
function EmployerCostCalculatorPage$render$lambda_14($this$text) {
  return 'Admin (' + numberToInt(0.15 * 100) + '%)';
}
function EmployerCostCalculatorPage$render$lambda_15($this$text, it) {
  return Cents__toString$default_impl_dffhix(it.administration_1, VOID, true);
}
function EmployerCostCalculatorPage$render$lambda_16($this$text) {
  return 'Month total';
}
function EmployerCostCalculatorPage$render$lambda_17($this$text, it) {
  return Cents__toString$default_impl_dffhix(it.get_total_5dhz70_k$(), VOID, true);
}
function EmployerCostCalculatorPage$render$lambda_18($this$custom) {
  return 'Remaining';
}
function EmployerCostCalculatorPage$render$lambda_19($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = get_bold(dynamicThemed($this$custom, ($this$dynamicThemed) => Cents__compareTo_impl_jg87bs($this$dynamicThemed.invoke_r7m7el_k$(it).remaining_1, Companion_instance.get_cents_3bbzqx_k$(0)) < 0 ? DangerTextSemantic_getInstance() : None_instance));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(it).remaining_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function EmployerCostCalculatorPage$render$lambda_20($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
var EmployerCostCalculatorPageClass;
function EmployerCostCalculatorPage() {
  if (EmployerCostCalculatorPageClass === VOID) {
    class $ {
      constructor() {
        this.committed_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0)));
        this.employerSharePercent_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(25.0);
        var tmp = this;
        // Inline function 'kotlin.let' call
        var it = today();
        var tmp$ret$0 = YearMonth().new_kotlinx_datetime_YearMonth_rn1bif_k$(it.year_1, it.get_month_ivc8d3_k$());
        tmp.start_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        this.monthCount_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(12);
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$2 = emptyMap();
        tmp_0.entered_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$2);
        var tmp_1 = this;
        tmp_1.rates_1 = remember(VOID, VOID, VOID, VOID, EmployerCostCalculatorPage$rates$lambda);
        var tmp_2 = this;
        tmp_2.children_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.rates_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$5 = new (ID())(item.first_1._id_1);
            destination.add_utx5q5_k$(tmp$ret$5);
          }
          var templates = destination;
          var tmp0 = until(0, $this$remember.invoke_r7m7el_k$(this.monthCount_1));
          // Inline function 'kotlin.collections.mapOf' call
          // Inline function 'kotlin.collections.scan' call
          var tmp2 = emptyMap();
          var tmp$ret$8;
          $l$block: {
            // Inline function 'kotlin.collections.runningFold' call
            var estimatedSize = collectionSizeOrDefault(tmp0, 9);
            if (estimatedSize === 0) {
              tmp$ret$8 = listOf(tmp2);
              break $l$block;
            }
            // Inline function 'kotlin.apply' call
            var this_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(estimatedSize + 1 | 0);
            this_1.add_utx5q5_k$(tmp2);
            var result = this_1;
            var accumulator = tmp2;
            var inductionVariable = tmp0.first_1;
            var last = tmp0.last_1;
            if (inductionVariable <= last)
              do {
                var element = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp0_0 = accumulator;
                var month = element;
                // Inline function 'kotlin.collections.associateWith' call
                var result_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(templates, 10)), 16));
                // Inline function 'kotlin.collections.associateWithTo' call
                var _iterator__ex2g4s_0 = templates.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
                  var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
                  var it = element_0.raw_1;
                  var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$(this.entered_1).get_wei43m_k$(to(month, new (ID())(it)));
                  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? tmp0_0.get_wei43m_k$(new (ID())(it)) : tmp0_elvis_lhs;
                  var tmp$ret$14 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
                  result_0.put_4fpzoq_k$(element_0, tmp$ret$14);
                }
                accumulator = result_0;
                result.add_utx5q5_k$(accumulator);
              }
               while (!(element === last));
            tmp$ret$8 = result;
          }
          var tmp$ret$7 = tmp$ret$8;
          return drop(tmp$ret$7, 1);
        });
        var tmp_3 = this;
        tmp_3.estimate_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(this.committed_1);
          var tmp_0 = $this$remember.invoke_r7m7el_k$(this.employerSharePercent_1) / 100;
          var tmp_1 = $this$remember.invoke_r7m7el_k$(this.start_1);
          // Inline function 'kotlin.collections.associate' call
          var this_0 = $this$remember.invoke_r7m7el_k$(this.rates_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var template = element.component1_7eebsc_k$();
            var price = element.component2_7eebsb_k$().inCents_1;
            // Inline function 'kotlin.collections.plusAssign' call
            var pair = to(new (ID())(template._id_1), new (Cents())(price));
            destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
          }
          return estimateEmployerCost(tmp.inCents_1, tmp_0, tmp_1, destination, $this$remember.invoke_r7m7el_k$(this.children_1));
        });
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Employer Cost Calculator'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.fullWidthPage' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        h1(element, 'Employer Cost Calculator');
        subtext(element, 'An estimate for a prospective employer. Nothing here is saved. Each child is charged the current full time daily rate for every weekday of the month.');
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_1 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Amount committed';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        tmp0.willAddChild_hz2iwc_k$(element_1);
        element_1.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$17 = themed(element_1, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = get_unpadded(tmp$ret$17);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_2.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_3 = get_centered(element_2);
        var tmp$ret$22 = themed(this_3, ForcePaddingSemantic_getInstance());
        text(tmp$ret$22, '$');
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_4 = weight(element_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
        var this_5 = themed(this_4, ForcePaddingSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (NumberInput())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_align_ypalx0_k$(Align_End_getInstance());
        var tmp = EmployerCostCalculatorPage$render$lambda;
        element_3.bind_gesskf_k$(element_3.content_1, this.committed_1.lens_drj4fu_k$(tmp, EmployerCostCalculatorPage$render$lambda_0));
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        element_2.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_2);
        element_1.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0_0 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label_0 = 'Starting month';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_0.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        tmp0_0.willAddChild_hz2iwc_k$(element_4);
        element_4.set_content_lzqutq_k$(label_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(element_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element_4.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(false);
        var tmp_0 = get_centered(element_5);
        var tmp_1 = Companion_getInstance_1().chevronLeft_1;
        var tmp_2 = EmployerCostCalculatorPage$render$lambda_1;
        iconButton(tmp_0, tmp_1, tmp_2, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, EmployerCostCalculatorPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_centered(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_7 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_7.willAddChild_hz2iwc_k$(element_6);
        element_6.set_align_ypalx0_k$(Align_Center_getInstance());
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_5, ($this$invoke) => renderToString($this$invoke.invoke_r7m7el_k$(this.start_1)));
        element_6.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_6);
        var tmp_6 = get_centered(element_5);
        var tmp_7 = Companion_getInstance_1().chevronRight_1;
        var tmp_8 = EmployerCostCalculatorPage$render$lambda_2;
        iconButton(tmp_6, tmp_7, tmp_8, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, EmployerCostCalculatorPage$render$lambda$slambda_0(this));
          return Unit_instance;
        });
        element_5.onStartup_vrxh3i_k$();
        element_4.addChild_2qpft2_k$(element_5);
        element_4.onStartup_vrxh3i_k$();
        tmp0_0.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0_1 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label_1 = 'Number of months (up to 19)';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_1.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        tmp0_1.willAddChild_hz2iwc_k$(element_7);
        element_7.set_content_lzqutq_k$(label_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
        var this_8 = themed(element_7, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (NumberInput())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_8.willAddChild_hz2iwc_k$(element_8);
        element_8.set_align_ypalx0_k$(Align_End_getInstance());
        element_8.set_keyboardHints_w6k1he_k$(Companion_getInstance_2().integer_1);
        element_8.set_range_a3mq0h_k$(rangeTo(1.0, 19));
        var tmp_9 = EmployerCostCalculatorPage$render$lambda_3;
        element_8.bind_gesskf_k$(element_8.content_1, this.monthCount_1.lens_drj4fu_k$(tmp_9, EmployerCostCalculatorPage$render$lambda_4));
        element_8.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_8);
        element_7.onStartup_vrxh3i_k$();
        tmp0_1.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0_2 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label_2 = 'Employer share of care';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_2.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        tmp0_2.willAddChild_hz2iwc_k$(element_9);
        element_9.set_content_lzqutq_k$(label_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$58 = themed(element_9, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_9 = get_unpadded(tmp$ret$58);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_9.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_10 = weight(element_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
        var this_11 = themed(this_10, ForcePaddingSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (NumberInput())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_11.willAddChild_hz2iwc_k$(element_11);
        element_11.set_align_ypalx0_k$(Align_End_getInstance());
        element_11.set_range_a3mq0h_k$(rangeTo(0.0, 100.0));
        var tmp_10 = EmployerCostCalculatorPage$render$lambda_5;
        element_11.bind_gesskf_k$(element_11.content_1, this.employerSharePercent_1.lens_drj4fu_k$(tmp_10, EmployerCostCalculatorPage$render$lambda_6));
        element_11.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
        var this_12 = get_centered(element_10);
        var tmp$ret$68 = themed(this_12, ForcePaddingSemantic_getInstance());
        text(tmp$ret$68, '%');
        element_10.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_10);
        element_9.onStartup_vrxh3i_k$();
        tmp0_2.addChild_2qpft2_k$(element_9);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_13.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(true);
        var tmp_11 = EmployerCostCalculatorPage$render$lambda_7;
        keyValue(element_12, tmp_11, ($this$keyValue) => {
          var tmp0 = $this$keyValue.invoke_r7m7el_k$(this.estimate_1);
          // Inline function 'kotlin.collections.fold' call
          var accumulator = new (Cents())(Companion_instance.get_cents_3bbzqx_k$(0));
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var sum = accumulator.inCents_1;
            accumulator = new (Cents())(Cents__plus_impl_qsv4s8(sum, element.get_total_5dhz70_k$()));
          }
          var tmp$ret$74 = accumulator.inCents_1;
          return Cents__toString$default_impl_dffhix(tmp$ret$74, VOID, true);
        });
        var tmp_12 = EmployerCostCalculatorPage$render$lambda_8;
        keyValue(element_12, tmp_12, ($this$keyValue) => {
          var tmp0_safe_receiver = lastOrNull($this$keyValue.invoke_r7m7el_k$(this.estimate_1));
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.remaining_1;
          var tmp;
          var tmp_0 = tmp1_safe_receiver;
          if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = Cents__toString$default_impl_dffhix(tmp1_safe_receiver, VOID, true);
          }
          var tmp2_elvis_lhs = tmp;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_14 = themed(element_12, DangerTextSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (TextView())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_14.willAddChild_hz2iwc_k$(element_13);
        var tmp_13 = KMutableProperty0();
        var tmp_14 = TextView$_get_content_$ref_4pzcwl(element_13);
        var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb(element_13));
        element_13.invoke_bnq13k_k$(tmp_15, ($this$invoke) => {
          var tmp0 = $this$invoke.invoke_r7m7el_k$(this.estimate_1);
          var tmp$ret$79;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (Cents__compareTo_impl_jg87bs(element.remaining_1, Companion_instance.get_cents_3bbzqx_k$(0)) < 0) {
                tmp$ret$79 = element;
                break $l$block;
              }
            }
            tmp$ret$79 = null;
          }
          var runsOut = tmp$ret$79;
          return runsOut == null ? '' : 'The commitment runs out in ' + renderToString(runsOut.month_1) + '.';
        });
        element_13.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_13);
        element_12.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_12);
        subtext(element, "Type the number of children in each month's row. A month you leave blank keeps the month before's count, shown faded.");
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        element.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(true);
        var $this$col = element_14;
        reactive($this$col, VOID, ($this$reactive) => {
          $this$col.clearChildren_eufjq4_k$();
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$reactive.invoke_r7m7el_k$(this.rates_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$87 = item.first_1;
            destination.add_utx5q5_k$(tmp$ret$87);
          }
          var groups = destination;
          var dailyRate = toMap($this$reactive.invoke_r7m7el_k$(this.rates_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_1 = themed($this$col, TableSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_1.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.important' call
          var tmp$ret$92 = themed(element, ImportantSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_2 = themed(tmp$ret$92, TableHeaderSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          text(themed(weight(element_0, 1.3), TableCellSemantic_getInstance()), 'Month');
          text(themed(weight(element_0, 0.6), TableCellSemantic_getInstance()), 'Days');
          var _iterator__ex2g4s_0 = groups.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var group = _iterator__ex2g4s_0.next_20eer_k$();
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            var this_3 = themed(weight(element_0, 1.0), TableCellSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            this_3.willAddChild_hz2iwc_k$(element_1);
            element_1.set_vertical_nuap32_k$(true);
            text(element_1, group.name_1);
            subtext(element_1, Cents__toString$default_impl_dffhix(getValue(dailyRate, group).inCents_1, VOID, true) + '/day');
            element_1.onStartup_vrxh3i_k$();
            this_3.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          var inductionVariable = 0;
          if (inductionVariable < 19)
            do {
              var month = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              var this_4 = shownWhen(element, VOID, VOID, EmployerCostCalculatorPage$render$lambda$lambda(month, this));
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
              ensureOutermostElement(element_2);
              this_4.willAddChild_hz2iwc_k$(element_2);
              element_2.set_vertical_nuap32_k$(false);
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              var this_5 = themed(weight(element_2, 1.3), TableCellSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_3 = new (TextView())(this_5.get_context_h02k06_k$());
              ensureOutermostElement(element_3);
              this_5.willAddChild_hz2iwc_k$(element_3);
              var tmp = KMutableProperty0();
              var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_3);
              var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_3));
              element_3.invoke_bnq13k_k$(tmp_1, EmployerCostCalculatorPage$render$lambda$lambda_0(this, month));
              element_3.onStartup_vrxh3i_k$();
              this_5.addChild_2qpft2_k$(element_3);
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              var this_6 = themed(weight(element_2, 0.6), TableCellSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_4 = new (TextView())(this_6.get_context_h02k06_k$());
              ensureOutermostElement(element_4);
              this_6.willAddChild_hz2iwc_k$(element_4);
              var tmp_2 = KMutableProperty0();
              var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
              var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
              element_4.invoke_bnq13k_k$(tmp_4, EmployerCostCalculatorPage$render$lambda$lambda_1(this, month));
              element_4.onStartup_vrxh3i_k$();
              this_6.addChild_2qpft2_k$(element_4);
              var _iterator__ex2g4s_1 = groups.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
                var group_0 = _iterator__ex2g4s_1.next_20eer_k$();
                var key = to(month, new (ID())(group_0._id_1));
                // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
                var this_7 = weight(element_2, 1.0);
                // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
                var this_8 = themed(this_7, FieldSemantic_getInstance());
                // Inline function 'com.lightningkite.kiteui.views.write' call
                var element_5 = new (NumberInput())(this_8.get_context_h02k06_k$());
                ensureOutermostElement(element_5);
                this_8.willAddChild_hz2iwc_k$(element_5);
                element_5.set_align_ypalx0_k$(Align_End_getInstance());
                element_5.set_keyboardHints_w6k1he_k$(Companion_getInstance_2().integer_1);
                element_5.set_range_a3mq0h_k$(rangeTo(0.0, 1000.0));
                var tmp_5 = KMutableProperty0();
                var tmp_6 = NumberInput$_get_hint_$ref_e9o7na(element_5);
                var tmp_7 = getPropertyCallableRef('hint', 0, tmp_5, tmp_6, NumberInput$_set_hint_$ref_r2kj42(element_5));
                element_5.invoke_bnq13k_k$(tmp_7, EmployerCostCalculatorPage$render$lambda$lambda_2(this, month, group_0));
                var tmp_8 = EmployerCostCalculatorPage$render$lambda$lambda_3(key);
                element_5.bind_gesskf_k$(element_5.content_1, this.entered_1.lens_u4wb4z_k$(tmp_8, EmployerCostCalculatorPage$render$lambda$lambda_4(key)));
                element_5.onStartup_vrxh3i_k$();
                this_8.addChild_2qpft2_k$(element_5);
              }
              element_2.onStartup_vrxh3i_k$();
              this_4.addChild_2qpft2_k$(element_2);
            }
             while (inductionVariable < 19);
          element.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element);
          return element;
        });
        element_14.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_14);
        var tmp_16 = EmployerCostCalculatorPage$render$lambda_9;
        var tmp_17 = Companion_instance_1;
        var tmp_18 = EmployerCostCalculatorPage$render$lambda_10;
        var tmp_19 = tmp_17.text$default_gwb2zv_k$(tmp_18, VOID, EmployerCostCalculatorPage$render$lambda_11);
        var tmp_20 = Companion_instance_1;
        var tmp_21 = EmployerCostCalculatorPage$render$lambda_12;
        var tmp_22 = tmp_20.text$default_gwb2zv_k$(tmp_21, VOID, EmployerCostCalculatorPage$render$lambda_13);
        var tmp_23 = Companion_instance_1;
        var tmp_24 = EmployerCostCalculatorPage$render$lambda_14;
        var tmp_25 = tmp_23.text$default_gwb2zv_k$(tmp_24, VOID, EmployerCostCalculatorPage$render$lambda_15);
        var tmp_26 = Companion_instance_1;
        var tmp_27 = EmployerCostCalculatorPage$render$lambda_16;
        var tmp_28 = tmp_26.text$default_gwb2zv_k$(tmp_27, VOID, EmployerCostCalculatorPage$render$lambda_17);
        var tmp_29 = Companion_instance_1;
        var tmp_30 = EmployerCostCalculatorPage$render$lambda_18;
        table(element, this.estimate_1, tmp_16, [tmp_19, tmp_22, tmp_25, tmp_28, tmp_29.custom$default_tn6l2s_k$(tmp_30, VOID, EmployerCostCalculatorPage$render$lambda_19)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_15 = shownWhen(element, VOID, VOID, EmployerCostCalculatorPage$render$lambda_20);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Space())(this_15.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_15);
        this_15.willAddChild_hz2iwc_k$(element_15);
        element_15.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_15);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'EmployerCostCalculatorPage', EmployerCostCalculatorPage, VOID, [Page()]);
    EmployerCostCalculatorPageClass = $;
  }
  return EmployerCostCalculatorPageClass;
}
//region block: exports
export {
  EmployerCostCalculatorPage as EmployerCostCalculatorPage3hdtsayh3aqer,
};
//endregion

//# sourceMappingURL=EmployerCostCalculatorPage.mjs.map
